import { usePrimitive } from "./common";
import React from "react";
export const ListItem = React.forwardRef((props, ref) => {
    const { Element, elementProps } = usePrimitive(props, "li");
    return (React.createElement(Element, { ref: ref, role: Element === "li" ? "group" : "listitem", ...elementProps }));
});
//# sourceMappingURL=ListItem.js.map